"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.detectTasksTool = void 0;
const zod_1 = require("zod");
exports.detectTasksTool = {
    name: 'detectTasks',
    description: `Call this tool when the user explicitly requests task-related actions or talks about the task as completed.

    Tasks are listed in <associated_todos><tool> in <tool-item> tags.

    This tool processes task/todo operations when the user talks about <tool-item> title as finished or done as it says or directly commands:
    - "Mark task X as done"
    - "Complete task Y" 
    - "Mark task Z as not done"
    - "Uncheck task A"
    - "I completed task B"
    - "Task C is finished"
    - (If f.e. task title is play 2 videos about AI) "I did play 2 videos about AI"
    
    DO NOT call this tool for:    
    - General conversation about tasks
    - Mentioning tasks without explicit completion commands
    - Planning or discussing tasks
    - Tutorial content that mentions tasks
    use this tool ONLY if the user explicitly talks about a task as completed or commands to mark it as done/not done. If the user is just talking about tasks without explicitly marking them as done or not done, do NOT call this tool. This tool is specifically for processing task completion status updates based on user commands or statements about task completion.
        
    This tool handles its own response continuation - you will continue responding normally after it executes.
    `,
    zodSchema: zod_1.z.object({
        taskData: zod_1.z.object({
            tasks: zod_1.z.array(zod_1.z.object({
                id: zod_1.z.number().describe('Unique identifier for the task'),
                title: zod_1.z.string().describe('The main task title or description'),
                done: zod_1.z.boolean().describe('Whether the task is marked as completed').default(false),
                items: zod_1.z.array(zod_1.z.object({
                    id: zod_1.z.number().describe('Unique identifier for the subtask or checklist item'),
                    title: zod_1.z.string().describe('Subtask or checklist item title'),
                    done: zod_1.z.boolean().describe('Whether the subtask is completed').default(false)
                })).describe('Array of subtasks or checklist items').optional()
            })).describe('Array of detected tasks from the user message'),
            notes: zod_1.z.array(zod_1.z.string()).describe('Additional notes or context about the tasks').optional()
        }).describe('Object containing categorized task data detected from the user message')
    }),
    blockStream: false
};
